import { type NotificationPreferences } from '@choco-admin/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Input } from '../../../../../../../components/FormComponents';

export const EmailNotifications: React.FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<NotificationPreferences>();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Email Notifications</h3>

      <div className="space-y-4">
        <Input
          id="orderEmails"
          label="Order Emails"
          {...register('email.orderUpdates')}
          errorMessage={errors.email?.orderUpdates?.message}
          isInvalid={!!errors.email?.orderUpdates}
          className="max-w-md"
          onChange={(value) => {
            const event = { target: { value } };
            register('email.orderUpdates').onChange(event);
          }}
        />

        <Input
          id="messageEmails"
          label="Message Emails"
          {...register('email.systemAlerts')}
          errorMessage={errors.email?.systemAlerts?.message}
          isInvalid={!!errors.email?.systemAlerts}
          className="max-w-md"
          onChange={(value) => {
            const event = { target: { value } };
            register('email.systemAlerts').onChange(event);
          }}
        />

        <Input
          id="complaintEmails"
          label="Complaint Emails"
          {...register('email.security')}
          errorMessage={errors.email?.security?.message}
          isInvalid={!!errors.email?.security}
          className="max-w-md"
          onChange={(value) => {
            const event = { target: { value } };
            register('email.security').onChange(event);
          }}
        />
      </div>
    </div>
  );
};
